import React from 'react';


interface EMDGheaderProps {
    dark?: boolean;
    children: React.ReactNode;
    className?: string;
}

const EMDGheader: React.FC<EMDGheaderProps> = ({ dark, children, className = '' }) => (
    <div className={`emdg-header ${className}${dark ? ' emdg-header--dark' : ''}`} role="banner">
        {children}
    </div>
);

export default EMDGheader;
